var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars, import/extensions
import { InjectorScope } from '@slickdeals/durango/dist/javascript/core/injector';
import { injectable } from '@slickdeals/durango/dist/javascript/decorators/injectable';
import { firstToUpperCase } from '@slickdeals/durango/dist/javascript/utilities/string';
import Label, { Modifiers } from '../components/label';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import JsxComponent from '../core/jsxComponent';
const name = 'DealCardLabelService';
export var LabelTypes;
(function (LabelTypes) {
    LabelTypes["Personalized"] = "personalized";
    LabelTypes["New"] = "new";
    LabelTypes["Expired"] = "expired";
    LabelTypes["Promoted"] = "promoted";
    LabelTypes["Popular"] = "popular";
    LabelTypes["Frontpage"] = "frontpage";
})(LabelTypes || (LabelTypes = {}));
export const LabelWeight = {
    [LabelTypes.New]: 10,
    [LabelTypes.Personalized]: 20,
    [LabelTypes.Promoted]: 30,
    [LabelTypes.Expired]: 40,
    [LabelTypes.Popular]: 50,
    [LabelTypes.Frontpage]: 60,
};
/**
 * TODO: Source this from DealCards once it's moved into blueprint-twig
 * TEMPORARY
 */
export var DealCardAttributes;
(function (DealCardAttributes) {
    DealCardAttributes["Personalized"] = "labelPersonalized";
    DealCardAttributes["New"] = "labelNew";
    DealCardAttributes["Expired"] = "labelExpired";
    DealCardAttributes["Promoted"] = "labelPromoted";
    DealCardAttributes["Popular"] = "labelPopular";
    DealCardAttributes["Frontpage"] = "labelFrontpage";
})(DealCardAttributes || (DealCardAttributes = {}));
let DealCardLabelService = class DealCardLabelService {
    /**
     * Returns the label for a deal card (if applicable)
     *
     * @param dealCardElement The deal card element to retrieve a label for
     */
    // TODO - Change HTMLLIElement -> DealCardElement once DealCard is in blueprint-twig
    // eslint-disable-next-line consistent-return
    getLabel(dealCardElement) {
        const labelOptions = this.getLabelOptions(dealCardElement);
        if (!labelOptions.length) {
            return;
        }
        const labelType = this.calculateLabelType(labelOptions);
        if (labelType === LabelTypes.New) {
            // TODO - Use DataAttributes enum once DealCard is in blueprint-twig
            const postedAt = Number(dealCardElement.dataset.postedAt);
            if (this.canShowNewLabel(postedAt) === false) {
                return;
            }
        }
        const modifier = [Modifiers[firstToUpperCase(labelType)]] ?? [];
        // eslint-disable-next-line consistent-return
        return JsxComponent.parseJsx(Label, { modifiers: modifier }, labelType);
    }
    /**
     * Calculates what label to use based on a weighted scale
     *
     * @param labelOptions Deal cards label preferences
     */
    // eslint-disable-next-line class-methods-use-this
    calculateLabelType(labelOptions) {
        // eslint-disable-next-line array-callback-return, consistent-return
        const label = labelOptions.reduce((winningLabel, labelType) => {
            if (LabelWeight[labelType] > LabelWeight[winningLabel]) {
                return labelType;
            }
        });
        return label;
    }
    /**
     * Fetches the active label options from the deal card data attributes
     *
     * @param dealCardElement The deal card element
     */
    // TODO - Change HTMLLIElement -> DealCardElement once DealCard is in blueprint-twig
    // eslint-disable-next-line class-methods-use-this
    getLabelOptions(dealCardElement) {
        const labelAttributes = Object.keys(dealCardElement.dataset).filter(attributeName => {
            if (!attributeName.startsWith('label')) {
                return false;
            }
            return dealCardElement.dataset[attributeName] === '1';
        }).map(attribute => {
            const parsedLabelType = attribute.replace('label', '');
            return LabelTypes[parsedLabelType];
        });
        return labelAttributes;
    }
    /**
     * Determines if the new label should show
     *
     * @param postedAt Time the deal was posted
     */
    // eslint-disable-next-line class-methods-use-this
    canShowNewLabel(postedAt) {
        /**
         * This is not the way to handle cookies, there is a ticket to clean this up
         *
         * TODO: Implement and use new functionality in the cookie service
         *
         * @see https://jira.slickdeals.net/browse/SLICKDEALS-68308
         */
        const lastVisitCookie = document.cookie.split('; ').find((row) => row.startsWith('lastfpvisit2'));
        let lastVisitEpoch;
        if (lastVisitCookie) {
            lastVisitEpoch = Number(lastVisitCookie.split('=').pop());
        }
        if (!lastVisitEpoch) {
            lastVisitEpoch = 0;
        }
        return lastVisitEpoch < postedAt;
    }
};
DealCardLabelService = __decorate([
    injectable({
        key: name,
        scope: InjectorScope.Singleton,
    })
], DealCardLabelService);
export default DealCardLabelService;
